// extracted by mini-css-extract-plugin
export default {"mainInputsCont":"NumberPageModule_mainInputsCont__OdaVk","inputField":"NumberPageModule_inputField__mSult","gap":"NumberPageModule_gap__6v5xW"};